module.exports = __webpack_public_path__ + "img/gpt-ios-step-0.b70af00a.png";